export default __webpack_public_path__ + "static/media/Individual.8e70187a.svg";